export const environment = {
  production: false,
  userAdminPanelApiUrl: "https://verify-users-pre.salicru.com/api"
};
